module.exports = __webpack_public_path__ + "static/img/teamwork.5276ed95.png";